export default {
  trackingOrder: '/api/v3/tracking',
};
